interface StateBannerProps {
  kind: "loading" | "error" | "missing";
  message: string;
  onRetry?: () => void;
}

/** 読込中/欠損/エラーを区別表示する共通バナー（AC-8）。 */
export function StateBanner({ kind, message, onRetry }: StateBannerProps) {
  return (
    <div className={`state-banner ${kind}`} role={kind === "error" ? "alert" : "status"}>
      <span>
        {kind === "loading" ? "読み込み中… " : kind === "error" ? "エラー: " : "データ欠損: "}
        {message}
      </span>
      {onRetry && <button onClick={onRetry}>再試行</button>}
    </div>
  );
}
